import { ModelBase } from '../../core/model/model-base';
import { PostalAddress } from '../../common/model/postal-address';
import { Address } from '../../common/model/address';
import { SelectionItem } from '../../core/component/select/select.component';
import { ContactIdKind } from './contact';

export class Tenant extends ModelBase {
  constructor(id: string = null) {
    super();
    if (id) {
      this.id = id;
    }
    this.idType = ContactIdKind.None;
    this.contactIdentification = '';
    this.phone = '';
    this.email = '';
    this.counterpart = '';
    this.invoiceAddress = new PostalAddress();
  }

  address: Address;
  idType: ContactIdKind;
  contactIdentification: string;
  counterpart: string;
  contactNumber: string;
  invoiceAddress: PostalAddress;
  leaseAgreementNumber: string;
  name: string;
  email: string;
  emailInvoicing: string;
  phone: string;
  contactId: string;

  toAutocompleteValue(consumerType?: 'list' | 'field', culture?: string): string {
    if (consumerType) {
      switch (consumerType) {
        case 'field':
          return `${this.contactNumber} ${this.name}`;
        case 'list':
          if (this.leaseAgreementNumber) {
            if (this.address && this.address.street) {
              return `${this.leaseAgreementNumber}, ${this.address.street}, ${this.name}`;
            }
            return `${this.leaseAgreementNumber}, ${this.name}`;
          }
          return `${this.contactNumber} ${this.name}${this.contactIdentification ? ' ' + this.contactIdentification : ''}`;
      }
    }
  }

  toJSON() {
    return this.id;
  }

  toSelectionItem() {
    if (this.leaseAgreementNumber && this.address) {
      return new SelectionItem(
        `${this.leaseAgreementNumber ? this.leaseAgreementNumber + ', ' : ''}${this.address.street ? this.address.street + ', ' : ''}, ${
          this.name
        }`,
        this.id
      );
    }
    return super.toSelectionItem();
  }

  toString() {
    return this.name;
  }
}
